import { render, staticRenderFns } from "./purchaseRetrunRedTask.vue?vue&type=template&id=037cfdf9&scoped=true"
import script from "./purchaseRetrunRedTask.vue?vue&type=script&lang=js"
export * from "./purchaseRetrunRedTask.vue?vue&type=script&lang=js"
import style0 from "./purchaseRetrunRedTask.vue?vue&type=style&index=0&id=037cfdf9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "037cfdf9",
  null
  
)

export default component.exports